import { UnscheduledWorkReportActions } from 'src/store/actions/unscheduledWorkReportActions';
const initialState = {
    loading: false,
    cacheId: undefined,
    data: []
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case UnscheduledWorkReportActions.GET_UNSCHEDULED_WORK_REPORT_REQUEST:
            return ({
                ...state,
                loading: true
            });
        case UnscheduledWorkReportActions.GET_UNSCHEDULED_WORK_REPORT_SUCCESS:
            return ({
                ...state,
                loading: false,
                cacheId: payload?.CacheId,
                data: payload?.EventData
            });
        case UnscheduledWorkReportActions.GET_UNSCHEDULED_WORK_REPORT_FAIL:
            return ({
                ...state,
                loading: false
            });
        default: return state;
    }
};
